import useAlert from "../../../../../../../use/useAlert";
import {useRef} from "react";
import Body from "../../../../../../../material/skeleton/Body";
import Box from "@mui/material/Box";
import {Button, TextField} from "@mui/material";
import Footer from "../../../../../../../material/skeleton/Footer";
import parameter from "../../../../../../../enum/parameter";
import {CheckCircle} from "@mui/icons-material";
import NotifyJustifyAdditionalMainWork from "./NotifyJustifyAdditionalMainWork";


export default function ({next}) {
    const alert = useAlert();
    const mainWorkInput = useRef();

    const nextStep = () => {
        if (mainWorkInput.current.value.length === 0) {
            alert.warning("Veuillez compléter le compte rendu");
            return;
        }

        next({
            justification: mainWorkInput.current.value
        });
    }

    return (
        <>
            <Body>
                <Box mt={2}>
                    <NotifyJustifyAdditionalMainWork/>
                </Box>
                <Box mt={5} px={2}>
                    <TextField
                        label={`Justifiez le/la main d'oeuvre supplémentaire`}
                        fullWidth={true}
                        multiline={true}
                        minRows={10}
                        maxRows={20}
                        inputRef={mainWorkInput}
                    />
                </Box>
            </Body>
            <Footer>
                <Button
                    sx={{height: parameter.FOOTER_HEIGHT, borderRadius: 0}}
                    startIcon={<CheckCircle/>}
                    variant="contained"
                    fullWidth
                    size={"large"}
                    onClick={nextStep}
                    data-test="button-next-step"
                >
                    Étape suivante
                </Button>
            </Footer>
        </>
    );
}